"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWithFailoverStrategy = requestWithFailoverStrategy;
const enums_1 = require("./enums");
const failoverStrategies_1 = require("./failoverStrategies");
function requestWithFailoverStrategy(method_1, path_1, config_1, postObject_1) {
    return __awaiter(this, arguments, void 0, function* (method, path, config, postObject, forceSingleEndpoint = false, timeoutOverride) {
        switch (config.failoverStrategy) {
            case enums_1.FailoverStrategy.AbortOnError:
                return yield (0, failoverStrategies_1.abortOnError)({ method, path, config, postObject, timeoutOverride });
            case enums_1.FailoverStrategy.TryNextOnError:
                return yield (0, failoverStrategies_1.tryNextOnError)({ method, path, config, postObject, timeoutOverride });
            case enums_1.FailoverStrategy.SingleEndpoint:
                return yield (0, failoverStrategies_1.singleEndpoint)({ method, path, config, postObject, timeoutOverride });
            case enums_1.FailoverStrategy.QueryMajority:
                if (forceSingleEndpoint) {
                    return yield (0, failoverStrategies_1.singleEndpoint)({ method, path, config, postObject, timeoutOverride });
                }
                return yield (0, failoverStrategies_1.queryMajority)({ method, path, config, postObject, timeoutOverride });
            default:
                throw new Error(`Unsupported failover strategy: ${config.failoverStrategy}`);
        }
    });
}
//# sourceMappingURL=requestWithFailoverStrategy.js.map